import { Layout } from 'antd';
import React, { useState } from 'react';
import Styles from '../Styles.module.scss';
import SidebarLogo from './SidebarLogo';
import SidebarMenu from './SidebarMenu';
import SidebarProfile from './SidebarProfile';

const Sidebar = () => {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <Layout.Sider
            width={288}
            collapsedWidth={80}
            className={Styles.sidebar}
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
            breakpoint="xl"
        >
            <SidebarLogo collapsed={collapsed} />
            <SidebarMenu collapsed={collapsed} />
            <SidebarProfile collapsed={collapsed} />
        </Layout.Sider>
    );
};

export default React.memo(Sidebar);
